import { render } from "./WhatIsBlockstory.vue?vue&type=template&id=38c5d512&scoped=true"
import script from "./WhatIsBlockstory.vue?vue&type=script&lang=js"
export * from "./WhatIsBlockstory.vue?vue&type=script&lang=js"

import "./WhatIsBlockstory.vue?vue&type=style&index=0&id=38c5d512&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c5d512"]])

export default __exports__